import React from "react";
const ErrorLoading = () => {
  return (
    <div className="Errorloading">
      <h4>What you are looking for is currently not available.</h4>
      <h5>Try another choice or refresh the page for an update!</h5>
    </div>
  );
};

export default ErrorLoading;